import { actionSet } from './utils'
import {
  FETCH_PRICEFY_CONFIG_SUCCESS,
  FETCH_PRICEFY_CONFIG_ERROR,
} from 'constants/actionTypes'
import API_URL from 'constants/api'
import Api from 'utils/ApiRequest'

export const fetchPricefyConfig = (token) => async (dispatch) => {
  try {
    const response = await new Api(token, dispatch).get(
      API_URL.FETCH_PRICEFY_CONFIG
    )

    return dispatch(
      actionSet(FETCH_PRICEFY_CONFIG_SUCCESS, response.data || {})
    )
  } catch (error) {
    return dispatch(actionSet(FETCH_PRICEFY_CONFIG_ERROR, error))
  }
}
